//#region IMPORT
import React, { useState, useEffect } from 'react';
import M_WOS_BASIC_01 from './M_WOS_BASIC_01';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { WorkingCheckActions } from '../../../Reducer/WorkingCheckReducer';
import useFcmHandler from '../../../Hooks/useFcmHandler';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSave1,
  useSave2,
  useSearch5,
} from './M_WOS_BASIC_01_Query';
import { useSave } from '../../../Hooks/useSave';
import useFileUpload from '../../../Hooks/useFileUpload';
import { WOS_BASIC_01_Schema } from './M_WOS_BASIC_01_Schema';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

const INPUTS = {
  workStopCd: '',
  depCd: '',
  stopAuth: '',
  stopComment: '',
  stopImagePath: '',
  userId: '',
};

export default function M_WOS_BASIC_01F() {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [workStopInputs, setWorkStopInputs] = useState(INPUTS);
  const [errors, setErrors] = useState({});
  const [selectedTargets, setSelectedTargets] = useState([]);
  const sendFcm = useFcmHandler();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [masterData, setMasterData] = useState([]);
  const workStopUpload = useFileUpload({
    oldFilePathField: 'image',
    newFileNameField: 'saveName',
    maxCount: 5,
    getTargetPath: () => `WorkStop/${userInfo.custCd}/WOS_BASIC_01`,
  });

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 스택형 뒤로가기로 변경: 작업 중지 작성 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickWos' })),
  });

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 중지'));
    // Search1Async({ userInfo });
  };

  //#region 쿼리

  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      if (rows?.[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: '인원 조회 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
      }
    },
  });

  const { refetch: Search5 } = useSearch5({
    onSuccess: (rows) => {
      const processed = (rows || []).map((item) => {
        const path = [
          item.depNm1,
          item.depNm2,
          item.depNm3,
          item.depNm4,
        ].filter(Boolean);
        return {
          ...item,
          pathArray: path,
          depth: path.length,
        };
      });
      setMasterData(processed);
    },
  });

  const { runAsync: getDepManagerAsync } = useSearch4();
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  const getStopAuth = () => {
    if (userInfo.authCd === 'HEAD_MANAGER') return '1';
    if (userInfo.authCd === 'BUSINESS_OWNER') return '2';
    return '0';
  };

  const { run: Save1 } = useSave({
    menuId: 'M_WOS_BASIC_01',
    schema: WOS_BASIC_01_Schema,
    saveData: () => ({
      workStopCd: workStopInputs.workStopCd ?? '',
      depCd: userInfo.depCd,
      stopAuth: getStopAuth(),
      stopComment: workStopInputs.stopComment ?? '',
      stopImagePath: '',
    }),
    requestSave: async (rows) => {
      const row = rows[0] ?? {};
      const res = await Save1Async({
        row: { ...row, stopImagePath: '' },
        userInfo,
      });
      const workStopCd = res?.[0]?.workStopCd ?? res?.workStopCd;
      if (!workStopCd) return res;

      setWorkStopInputs((prev) => ({ ...prev, workStopCd }));

      let stopImagePath = '';
      if (workStopUpload.previewList.filter((img) => !img.deleted).length > 0) {
        stopImagePath = (await workStopUpload.SaveLogicFile()) || '';
        await Save1Async({
          row: {
            ...row,
            workStopCd,
            stopImagePath,
          },
          userInfo,
        });
      }

      await SaveLogic3(workStopCd, getStopAuth());
      dispatch(showSnackbar({ message: '저장 완료', type: 'success' }));
      if (
        userInfo.authCd === 'BUSINESS_OWNER' ||
        userInfo.authCd === 'HEAD_MANAGER' ||
        (userInfo.authCd === 'EMPLOYEE' && userInfo.posiNm === '관리감독자')
      ) {
        navigate('/Home');
      } else {
        navigate(`/M_WorkStop/${workStopCd}`);
      }
      dispatch(WorkingCheckActions.setStopWorking(1));
      dispatch(WorkingCheckActions.setWorkStopCd(workStopCd));
      return res;
    },
  });
  //#endregion

  const SaveLogic3 = async (workStopCd, stopAuth) => {
    try {
      if (stopAuth === '0') {
        if (userInfo?.decUserId) {
          await Save2Async({
            row: { workStopCd, stopId: userInfo?.decUserId },
            userInfo,
          });
        }

        const managers = await getDepManagerAsync({ userInfo });
        const arr = Array.isArray(managers)
          ? managers
          : (managers?.data ?? managers?.Data ?? []);

        for (const mgr of arr) {
          if (!mgr.id) continue;
          await sendFcm({
            targetUserId: mgr.id,
            requestUserId: userInfo.userid,
            body: `${userInfo.userNm}님이 작업 중지를 요청했습니다.`,
            status: '작업중지',
            codeGroup: 'AL_006_001',
            title: '작업중지',
            route: '/M_WorkStop',
            responseData: workStopCd,
          });
        }
        return;
      }

      if (selectedTargets.length > 0) {
        const members = await Search3Async({
          depCdList: selectedTargets.map((t) => t.depCd),
        });

        const memberList = Array.isArray(members)
          ? members
          : (members?.data ?? members?.Data ?? []);

        for (const member of memberList) {
          if (!member.id) continue;

          await Save2Async({
            row: { workStopCd, stopId: member.id },
            userInfo,
          });

          await sendFcm({
            targetUserId: member.id,
            requestUserId: userInfo.userid,
            body: `${userInfo.userNm}님이 작업 중지를 요청했습니다.`,
            status: '작업중지',
            codeGroup: 'AL_006_001',
            title: '작업중지',
            route: '/M_WorkStop',
            responseData: workStopCd,
          });
        }
      }
    } catch (e) {
      console.error('SaveLogic3 Error:', e);
    }
  };

  return (
    <div>
      <M_WOS_BASIC_01
        location={location}
        workStopUpload={workStopUpload}
        selectedTargets={selectedTargets}
        setSelectedTargets={setSelectedTargets}
        errors={errors}
        setErrors={setErrors}
        workStopInputs={workStopInputs}
        setWorkStopInputs={setWorkStopInputs}
        SaveLogic1={Save1}
        masterData={masterData}
      />
    </div>
  );
}
